import Axios from 'axios'

const comunication = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  createNotification(notification) {
    return this.axios().post('/notification', notification)
  },
  updateNotification(notification) {
    return this.axios().put('/notification', notification)
  },
  getAllAlerts(limit = 20, offset = 0) {
    return this.axios().get(`/notification/obtain-all?limit=${limit}&offset=${offset}`)
  },
  markAlertAsRead(notification) {
    return this.axios().put('/notification/mark-as-read', notification)
  },
  disableAlert(id) {
    return this.axios().put('/notification/disable/' + id)
  },
  enableAlert(id) {
    return this.axios().put('/notification/enable/' + id)
  },
  getAlertsForLaboratory(notification) {
    return this.axios().get(
      '/notification/obtain-for-laboratory?id-laboratory=' +
        notification.idLaboratory +
        '&start-date=' +
        notification.startDate +
        '&end-date=' +
        notification.endDate +
        '&enabled=1'
    )
  },
  getMessagesForLaboratory(message) {
    return this.axios().get(
      '/message/obtain-for-laboratory?id-laboratory=' +
        message.idLaboratory +
        '&start-date=' +
        message.startDate +
        '&end-date=' +
        message.endDate +
        '&enabled=1'
    )
  },
  markMessageAsRead(message) {
    return this.axios().put(
      '/message/mark-as-read?id-message=' +
        message['id-message'] +
        '&id-laboratory=' +
        message['id-laboratory'] +
        '&read-date=' +
        message['read-date'] +
        '&id-operator=' +
        message['id-operator']
    )
  },
}

export default comunication
